import "./credit-empty.shared.scss";
import CREDIT_IMG from "../../assets/images/currency-coin.png";
import { Button } from "react-bootstrap";

interface CreditEmptyProps {
    credit_remaining: number;
    submit() :void
}
const CreditEmpty: React.FC<CreditEmptyProps> = ({ credit_remaining, submit }) => {

    const clickUnlockCandidate = () => {
        submit();
    }


    return (

        <>
            <div className="credit-empty-control">

                <img src={CREDIT_IMG} className="credit-empty-coin"></img>
                {
                    credit_remaining > 0 ?
                        <>
                            <span className="credit-empty-title">ข้อมูลผู้สมัครพร้อมแล้ว <br></br>ใช้ 1 เครดิตเพื่อเปิดดูรายงานการสัมภาษณ์</span>
                          
                            <Button className="button-std button-add-credit" onClick={clickUnlockCandidate}>กดใช้ 1 เครดิต เพื่อปลดล็อค</Button>
                        </> :
                        <>
                            <span className="credit-empty-title">ข้อมูลผู้สมัครพร้อมแล้ว <br></br>ใช้ 1 เครดิตเพื่อเปิดดูรายงานการสัมภาษณ์</span>
                            <span className="credit-empty-desc">กรุณาเติมเครดิตเพื่อใช้งาน ติดต่อสอบถามข้อมูล
                                แพ็กเกจเครดิตได้ที่ 02-038-2639, 094-924-6162
                                หรือคลิกที่ปุ่มด้านล่างนี้</span>

                            <Button className="button-std button-add-credit">เติมเครดิต</Button>
                        </>

                }

            </div>
        </>
    )
}

export default CreditEmpty;